import React, { useState, useRef, useEffect } from "react";
import { API_ENDPOINTS } from "../../../api";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useLoader } from "../../../Loader/LoaderContext";
import {
  deleteService,
  postService,
  putService,
} from "../../../servce/ApisService";
import {
  getDotColor,
  getSHiftDisplayName,
  getStatusClass,
  getStatusDisplayName,
} from "../../../utility/RolesUtility";
import { useToaster } from "../../../Toaster/Toaster";
import ConfirmationModal from "./Modals/ConfirmationModal";
import Pagination from "../usersMangmnt/Pagination";

interface Tag {
  id: number;
  name: string;
  status: string;
  addedBy: string;
}
const Tags = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [tags, setTags] = useState<Tag[]>([]);
  const [id, setId] = useState(0);
  const [tagName, setTagName] = useState(0);
  const [actionName, seActionName] = useState("");
  const [searchParams] = useSearchParams();
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userId = searchParams.get("appUserId");
  const [newTag, setNewTag] = useState("");
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const [editingTagId, setEditingTagId] = useState<number | null>(null);
  const [editTagName, setEditTagName] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState("");
  const { showToast } = useToaster();
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElement, setTotalElements] = useState(0);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = (index: number | null) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchTags = async () => {
    setLoading(true);
    let body: any = {
      page: currentPage,
      search: searchQuery,
      isAllData: false,
    };
    try {
      let url = "";

      if (userInfo.roles === "CHIEF_EDITOR") {
        url = API_ENDPOINTS.getTagChief;
      } else if (userInfo.roles === "JUNIOR_EDITOR") {
        url = API_ENDPOINTS.getTagJunior;
      } else if (userInfo.roles === "UPLOADER") {
        url = API_ENDPOINTS.getTagUploader;
      }

      const response = await postService(url, body);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
      console.log("API Response:", response);
      if (response?.data?.content && Array.isArray(response.data.content)) {
        setTags(response.data.content);
        console.log("Tags Content:", response.data.content);
      } else {
        setTags([]);
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
      setTags([]);
    } finally {
      setLoading(false);
    }
  };
  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };
  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
  const onPageChange = async (page: number) => {
    setCurrentPage(page);
  };
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchTags();
  }, [userInfo.roles, currentPage, searchQuery, isRefreshPage]);

  const handleAddTag = async () => {
    if (newTag.trim().length < 3) {
      setMessage("Tag must be at least 3 characters long.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    if (newTag.length > 20) {
      setMessage("Tag cannot exceed 20 characters.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    if (tags.some((tag) => tag.name.toLowerCase() === newTag.toLowerCase())) {
      setMessage("Tag name already exists.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    setLoading(true);
    try {
      let response;
      let url: any;
      const newTagData = { name: newTag };
      let payload: { name: string; id?: number } = { name: newTagData.name };
      if (userId) {
        payload.id = parseInt(userId, 10);
        if (userInfo.roles === "CHIEF_EDITOR") {
          url = API_ENDPOINTS.updatePostCheif;
        } else if (userInfo.roles === "JUNIOR_EDITOR") {
          url = API_ENDPOINTS.updatePost;
        } else if (userInfo.roles === "UPLOADER") {
          url = API_ENDPOINTS.updatePostUploader;
        } else if (userInfo.roles === "PUBLISHER") {
          url = API_ENDPOINTS.updatePostPublisher;
        }
        response = await postService(url, payload);
        setIsPopupOpen(false);
        showToast("Tag updated successfully!", "success", "");
      } else {
        if (userInfo.roles === "CHIEF_EDITOR") {
          url = API_ENDPOINTS.saveTagChief;
        } else if (userInfo.roles === "JUNIOR_EDITOR") {
          url = API_ENDPOINTS.saveTagJunior;
        } else if (userInfo.roles === "UPLOADER") {
          url = API_ENDPOINTS.saveTagUploader;
        }
        response = await postService(url, payload);
        setIsPopupOpen(false);
        showToast("Tag added successfully!", "success", "");
      }
      setNewTag("");

      setTimeout(() => setMessage(""), 3000);
      fetchTags(); // Refresh the tags list
    } catch (error: any) {
      if (error.response?.data?.message === "Tag already exists.") {
        setMessage(error.response?.data?.message);
      }
      console.error("Error saving user:", error);
      // showToast("","error",'');
      setTimeout(() => setMessage(""), 5000); // Clear message after 2 seconds
    } finally {
      setLoading(false);
    }
  };
  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  const handleConfirm = () => {
    if (actionName === "delete" || actionName === "deleteError") {
      submitDeleteTag();
    } else if (actionName === "approve") {
      handleSendApprove();
    } else if (actionName === "edit") {
      handleSaveEdit();
      setIsPopupOpen(false);
      setNewTag("");
    } else {
      handleAddTag();
      setIsPopupOpen(false);
    }
  };
  const submitDeleteTag = async () => {
    handleClosePopup();
    setLoading(true);
    setLoading(true);
    let url = "";
    if (userInfo.roles === "CHIEF_EDITOR") {
      url = API_ENDPOINTS.deleteTagChief;
    } else if (userInfo.roles === "JUNIOR_EDITOR") {
      url = API_ENDPOINTS.deleteTagJunior;
    } else if (userInfo.roles === "UPLOADER") {
      url = API_ENDPOINTS.deleteTagUploader;
    }

    // Get the token (from localStorage or any other source)
    const token = localStorage.getItem("authToken");

    try {
      let response: any;
      if (actionName === "deleteError") {
        response = await deleteService(
          url + "?id=" + id + "&isConfirmed=" + true
        );
      } else {
        response = await deleteService(url + "?id=" + id);
      }

      if (response.statusCode == 200) {
        setTags(tags.filter((tag) => tag.id !== id));
        showToast("Tag deleted successfully!", "success", "");
      }
      setIsPopupOpen(false);
    } catch (error: any) {
      if (error.response?.data?.message === "Cannot delete, tag is in use.") {
        setIsPopupOpen(true);
        seActionName("deleteError");
      } else if (
        error.response?.data?.message === "Cannot update, tag is in use."
      ) {
        setIsPopupOpen(true);
        seActionName("EditError");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleApproveTag = (tagData: any) => {
    setIsPopupOpen(true);
    setId(tagData?.id);
    setTagName(tagData.name);
    seActionName("approve");
  };
  const handleDeleteTag = async (id: number) => {
    setIsPopupOpen(true);
    setId(id);
    seActionName("delete");
  };

  const handleEditTag = (id: number, name: string) => {
    setActiveDropdown(null);
    setEditingTagId(id);
    setEditTagName(name);
    seActionName("edit");
    // setNewTag(name)
  };
  const handleSendApprove = async () => {
    let url;
    if (userInfo.roles === "UPLOADER") {
      url = `${API_ENDPOINTS.tagApproveUploader}?id=${id}`;
    } else if (userInfo.roles === "JUNIOR_EDITOR") {
      url = `${API_ENDPOINTS.tagApproveJunior}?id=${id}`;
    } else {
      url = `${API_ENDPOINTS.tagApproveCE}?id=${id}`;
      // return;
    }

    try {
      // Make the API call using PUT
      const response = await putService(url, { id, tagName });
      // if (response.status === 200 || response.status === 204) {
      fetchTags();
      setIsPopupOpen(false);

      showToast("Tag approved successfully!", "success", "");
      // }
    } catch (error) {}
  };

  const handleSaveEdit = async () => {
    if (!editingTagId) return;

    if (editTagName.length > 20) {
      setMessage("Tag cannot exceed 20 characters.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    if (
      tags.some(
        (tag) =>
          tag.name.toLowerCase() === editTagName.toLowerCase() &&
          tag.id !== editingTagId
      )
    ) {
      setMessage("Tag name already exists.");
      return;
    }
    const payload = { id: editingTagId, name: editTagName };
    let apiUrl = "";
    if (userInfo.roles === "CHIEF_EDITOR") {
      apiUrl = API_ENDPOINTS.updateTagChief;
    } else if (userInfo.roles === "JUNIOR_EDITOR") {
      apiUrl = API_ENDPOINTS.updateTagJunior;
    } else if (userInfo.roles === "UPLOADER") {
      apiUrl = API_ENDPOINTS.updateTagUploader;
    }

    try {
      setLoading(true);

      const response = await postService(apiUrl, payload);
      // if (response?.status === 200) {

      setIsPopupOpen(false);
      showToast("Tag updated successfully!", "success", "");
      fetchTags();
    } catch (error: any) {
      if (error.response?.data?.message === "Tag already exists.") {
        setMessage(error.response?.data?.message);
      }
    } finally {
      setLoading(false);
      setEditingTagId(null);
      setEditTagName("");
    }
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNewTag(value);
    // Real-time validation
    if (value.trim().length > 0 && value.trim().length < 3) {
      setMessage("Sector must be at least 3 characters long.");
    } else if (value.length > 20) {
      setMessage("Sector cannot exceed 20 characters.");
    } else {
      setMessage("");
    }
  };
  const addOrEdit = (name: string) => {
    if (name === "add") {
      setEditingTagId(null);
    }
    if (editingTagId) {
      if (editTagName.trim().length < 3) {
        setMessages("Tag must be at least 3 characters long.");
        setTimeout(() => setMessages(""), 3000);
        return;
      }
      if (editTagName.length > 20) {
        setMessages("Tag cannot exceed 20 characters.");
        setTimeout(() => setMessages(""), 3000);
        return;
      }
      setIsPopupOpen(true);
      setId(id);
      seActionName("edit");
    } else {
      setIsPopupOpen(true);
      seActionName("add");
    }
  };

  return (
    <div className="p-4 ">
      <div>
        <div className="flex items-center">
          <input
            type="text"
            value={newTag}
            onChange={handleInputChange}
            placeholder="Enter a tag"
            className="border p-2 mr-6 text-[#6B7280] font-normal font-Inter text-base w-[340px] rounded-md"
          />
          <button
            className="gradient-background text-white py-2 px-3 font-bold text-[14px] w-[76px] font-Inter"
            onClick={() => addOrEdit("add")}
          >
            Add
          </button>
        </div>
      </div>
      {message && <p className="text-red-600 mb-2">{message}</p>}
      <p className="mt-10 text-base font-semibold text-gray-700 mb-2 font-sans">
        Tags
      </p>

      {tags.length > 0 ? (
        tags.map((tag, index) => (
          <div
            key={tag.id}
            className="bg-white flex justify-between items-center pl-3 pr-6 py-2 mb-1 border-2 rounded-md font-Inter text-base font-medium"
          >
            {editingTagId === tag.id ? (
              <>
                <div>
                  <div className="flex items-center">
                    <input
                      type="text"
                      value={editTagName}
                      onChange={(e) => setEditTagName(e.target.value)}
                      className="border p-2 mr-2 text-base rounded-md"
                    />
                    <button
                      className="text-blue-500 mr-2"
                      onClick={() => addOrEdit("edit")}
                    >
                      Save
                    </button>
                    <button
                      className="text-gray-500"
                      onClick={() => {
                        setEditingTagId(null);
                        setEditTagName("");
                        setMessage("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                  {messages && <p className="text-red-600 mb-2">{messages}</p>}
                </div>
              </>
            ) : (
              <div className="flex justify-between items-center w-full relative">
                <p className="font-medium text-gray-900">{tag.name}</p>
                <div className="flex items-center">
                  <span>
                    <span
                      className={`px-3 py-1.5 rounded-full text-xs whitespace-nowrap font-semibold ${getStatusClass(
                        tag.status
                      )}`}
                    >
                      <span
                        className="inline-block w-2 h-2 mr-2 rounded-full"
                        style={{ backgroundColor: getDotColor(tag.status) }}
                      ></span>
                      {userInfo?.roles === "CHIEF_EDITOR" &&
                      tag?.status === "TO_CE_APPROVE"
                        ? `Received for Approval`
                        : getStatusDisplayName(tag?.status)}
                    </span>
                    {userInfo?.roles === "CHIEF_EDITOR" &&
                      tag?.status === "TO_CE_APPROVE" && (
                        <p className="text-end text-gray-500 text-[10px] mt-1">
                          from {tag?.addedBy}
                        </p>
                      )}
                  </span>

                  <div className="relative">
                    {((tag?.status === "TO_CE_APPROVE" &&
                      (userInfo?.roles === "JUNIOR_EDITOR" ||
                        userInfo?.roles === "UPLOADER")) ||
                      userInfo.roles === "CHIEF_EDITOR") && (
                      <img
                        src="/images/threeDot.svg"
                        alt="Menu"
                        className="cursor-pointer ml-5"
                        onClick={() => toggleDropdown(index)}
                      />
                    )}
                    {activeDropdown === index && (
                      <div
                        ref={dropdownRef}
                        className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10"
                      >
                        <span
                          className="flex px-4 cursor-pointer"
                          onClick={() => handleEditTag(tag.id, tag.name)}
                        >
                          <img src="/images/editIcon.svg" alt="Edit" />
                          <a
                            href="#"
                            className="ml-2 block py-2 text-sm text-[#374151] font-normal"
                          >
                            Edit
                          </a>
                        </span>
                        {userInfo.roles === "CHIEF_EDITOR" &&
                          tag.status !== "APPROVED" && (
                            <span
                              className="flex px-4 cursor-pointer"
                              onClick={() => handleApproveTag(tag)}
                            >
                              <img src="/images/approveTag.svg" alt="Edit" />
                              <a
                                href="#"
                                className="ml-2 block py-2 text-sm text-[#047857] font-normal"
                              >
                                Approve Tag
                              </a>
                            </span>
                          )}
                        {userInfo.roles === "CHIEF_EDITOR" &&
                          tag.status === "APPROVED" && (
                            <span
                              className="flex px-4 cursor-pointer text-green-600"
                              // onClick={() => handleEditTag(tag.id, tag.name)}
                            >
                              <img src="/images/editIcon.svg" alt="Edit" />
                              <Link
                                to={`/portals/posts/viewTagsSeoSettings/${tag.name}?id=${tag.id}`}
                                className="ml-2 block py-2 text-sm  font-normal"
                              >
                                Seo settings
                              </Link>
                            </span>
                          )}
                        <span
                          className="flex px-4 cursor-pointer"
                          onClick={() => handleDeleteTag(tag.id)}
                        >
                          <img src="/images/delete_icon.svg" alt="Delete" />
                          <a
                            href="#"
                            className="ml-2 block py-2 text-sm text-[#B91C1C] font-normal"
                          >
                            Delete
                          </a>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p className="text-gray-500 mt-4 text-center">No tags available.</p>
      )}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalElement={totalElement}
          onPageChange={onPageChange}
          onNext={onNext}
          onPrevious={onPrevious}
        />
      )}
      {isPopupOpen && (
        <ConfirmationModal
          onClose={handleClosePopup}
          onConfirm={handleConfirm}
          action={actionName}
        />
      )}
    </div>
  );
};
export default Tags;
